export default __webpack_public_path__ + "static/media/Black-01.0326d8e9.png";